import { useTranslation } from "react-i18next";
import { TableMenu } from "components";
import RCAConfirmDeleteModal from "pages/Corporate/RCA/components/RCAConfirmDeleteModal/RCAConfirmDeleteModal";
import { IssueEntity } from "entities/RCA/IssueEntity/IssueEntity";
import { useMemo, useState } from "react";
import moment from "moment";
import { IIssue } from "entities/RCA/IssueEntity/IIssueEntityInterfaces";
import { IOption } from "components/TableMenu/TableMenuInterfaces";
import { ApolloQueryResult, OperationVariables } from "@apollo/client";
import useRolesPermissions from "hooks/useRolesPermissions";

const IssueOptionsMenuCell = ({
    issue,
    refetch,
}: {
    issue: IIssue;
    refetch: (variables?: Partial<OperationVariables> | undefined) => Promise<ApolloQueryResult<any>>;
}) => {
    const { t } = useTranslation();
    const [openIssueDeleteModal, setOpenIssueDeleteModal] = useState<boolean>(false);
    const { updateIssueMutation } = IssueEntity.UpdateIssue();

    const rcaOwnershipIds = useMemo(
        () =>
            issue
                ? [
                      ...(issue?.owner?.user_id ? [issue.owner.user_id] : []),
                      ...(issue?.created_by ? [issue?.created_by] : []),
                  ]
                : [],
        [issue],
    );
    const { RCA_PERMISSIONS } = useRolesPermissions(rcaOwnershipIds);

    const handleDeleteIssue = async () => {
        const issueDetailValues = {
            deleted_at: moment.utc().toDate(),
        };

        try {
            await updateIssueMutation({
                variables: {
                    issueId: issue?.issue_id,
                    changes: {
                        ...issueDetailValues,
                    },
                },
            });
            refetch();
        } catch {
            return;
        }
    };

    const options: IOption[] = [
        {
            name: t("rca.issues.issue_detail.delete_issue"),
            callback: () => setOpenIssueDeleteModal(true),
            disabled: !RCA_PERMISSIONS?.issues?.canDelete,
        },
    ];

    return (
        <div>
            <TableMenu options={options} />{" "}
            <RCAConfirmDeleteModal
                open={openIssueDeleteModal}
                onClose={() => setOpenIssueDeleteModal(false)}
                onDeleteItem={handleDeleteIssue}
                title={t("rca.issues.issue_delete_modal.title")}
                warning={t("rca.issues.issue_delete_modal.warning")}
                confirm={t("rca.issues.issue_delete_modal.confirm")}
            />
        </div>
    );
};

export default IssueOptionsMenuCell;
